import { useQueryParam, DateQueryOptions } from 'labguard-cdk'

/**
 * Provide a date state and updater
 * Currently stored in query params
 */
export default function useSelectedDate() {
  return useQueryParam('date', DateQueryOptions)
}
